import { Component, Inject, inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-rfq-info-dialog',
  templateUrl: './rfq-info-dialog.component.html',
  styleUrls: ['./rfq-info-dialog.component.scss']
})

export class RfqInfoDialogComponent {
  readonly dialogRef = inject(MatDialogRef<RfqInfoDialogComponent>);
  title: string = "";
  message: string = "";
  messages: string[] = [];
  closeLabel: string = "Cancel";
  displaySubmit: boolean = false;
  selection?: DialogSelect = {
    display: false,
    selection: [],
    title: ""
  };
  selected: any = null;
  selectedId: number | null = null;
  type: RfqInfoDialogType = RfqInfoDialogType.default;
  abortCheck: string = "ABORT";
  abortInfo: string = `Enter “<checker>” to permanently abort this request. This action cannot be undone.`;
  
  rfqInfoDialogType = RfqInfoDialogType;
  abortControl: FormControl = new FormControl();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = data.title;
    this.message = data.message;
    this.messages = data.messages;
    this.displaySubmit = data.displaySubmit;
    this.selection = data.displaySelection;
    this.closeLabel = data.closeLabel ?? this.closeLabel;
    this.type = data.type as RfqInfoDialogType;
    this.abortInfo = data.abortInfo ?? this.abortInfo;
    this.abortCheck = data.abortCheck ?? this.abortCheck;
  }

  handleClose(submit?: boolean) {
    let payload;
    if(submit) {
      payload = this.selectedId;
    }
    this.dialogRef.close(payload);
  }

  isArray(variable: any): boolean {
    return Array.isArray(variable);
  }

  public get isSubmitDisabled(): boolean {
    if(this.type == this.rfqInfoDialogType.abort) {
      return this.abortControl.value != this.abortCheck || this.selectedId == null;
    }
    return false;
  }

  public get abortLabel(): string {
    return this.abortInfo.replace("<checker>", this.abortCheck);
  }

}

export interface DialogSelect {
  title: string;
  selection: any[];
  display: boolean;
}

export enum RfqInfoDialogType {
  abort = 'abort',
  default = 'default',
}